import React from 'react';
import './css/LoadingSpiner.css'; // Import the CSS file for styling

const LoadingSpinner = () => {
  return <div className="loading-spinner"></div>;
};

export default LoadingSpinner;